export { ProductManagementTabContent } from "./product-management";
export { SoftwareTabContent } from "./software";
export { MarketingTabContent } from "./marketing";
export { ProjectManagementTabContent } from "./project-management";
export { ITTabContent } from "./it";
export { DesignTabContent } from "./design";
